import axios from "axios";
import { keyLocalStorage } from "helpers/constants";
import { User } from "models/users/type_user";

const api = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
});

// Add a request interceptor
api.interceptors.request.use(
  async function (config) {
    const raw = localStorage.getItem(keyLocalStorage.USER_STORAGE);
    const user: User | null = raw ? JSON.parse(raw) : null;
    // Passando na request o access token do usuário logado
    config.headers.Authorization = `Bearer ${user && user.access_token}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response?.status;
    const requestUrl = String(error.config?.url ?? "");
    // Login também retorna 401 para credenciais inválidas — não deslogar nesse caso.
    if (
      status === 401 &&
      !requestUrl.includes("/users/admin/login")
    ) {
      localStorage.removeItem(keyLocalStorage.USER_STORAGE);
      window.location.assign("/authentication/sign-in/basic");
      return Promise.reject(error);
    }
    // Sem resposta HTTP (rede, servidor offline, timeout): error.response é undefined.
    // Devolver undefined faz o await resolver e quebra destructuring { data, status }.
    if (error.response) {
      return error.response;
    }
    return Promise.reject(error);
  }
);

export default api;
